import {httpConstants} from "../constants";
import {httpService} from "../utility/httpService";

export default {
    updateCatalogue,
    getUserCatalogue,
    getCatalogue,
}

async function getUserCatalogue(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.USER_CATALOGUE_LIST + `?userId=das&role=ADMIN&status=ALL`;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function updateCatalogue(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.UPDATE_CATALOGUE_STATUS;
    return httpService(httpConstants.METHOD_TYPE.PUT, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function getCatalogue(orderId) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.USER_CATALOGUE_BY_ID + `?id=${orderId}`;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), {}, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}


function getHeaders() {
    return {'Content-Type': httpConstants.CONTENT_TYPE.APPLICATION_JSON, 'skip': true}
}
